'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon } from '@repo/ui';
import { Timelock } from '@repo/ui/icons';
import { PendingActionsList, VaultPendingTimelockInfo } from '@/components/VaultPage/components/VaultPendingTimelockInfo';
import { StyledVaultPendingTimelock } from '@/components/VaultPage/VaultV1/VaultPendingTimelock/VaultPendingTimelock.components';
import type { VaultV2PendingTimelockChange } from './utils';
import { VaultV2PendingTimelockChangeTimelock, VaultV2PendingTimelockCountdown } from '../../VaultV2PendingTimelock/components';
export interface VaultV2TimelockDuration {
  functionName: string;
  duration: number;
}
interface VaultV2PendingTimelocksIndicatorProps {
  timelocks: VaultV2TimelockDuration[];
  pendingTimelocks: VaultV2PendingTimelockChange[];
}
const VaultV2PendingTimelocksIndicator = t0 => {
  const $ = _c(11);
  const {
    pendingTimelocks,
    timelocks
  } = t0;
  const t1 = pendingTimelocks.length;
  let t2;
  if ($[0] !== pendingTimelocks || $[1] !== timelocks) {
    let t3;
    if ($[3] !== timelocks) {
      t3 = (t4, index) => {
        const {
          type,
          functionName,
          newDuration,
          executableAt
        } = t4;
        return <StyledVaultPendingTimelock.Container key={`${functionName}-${index}`} selectable={false}><VaultV2PendingTimelockChangeTimelock newValue={newDuration} functionName={type} decodedFunctionName={functionName} timelocks={timelocks} /><VaultV2PendingTimelockCountdown validAt={executableAt} /></StyledVaultPendingTimelock.Container>;
      };
      $[3] = timelocks;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = pendingTimelocks.map(t3);
    $[0] = pendingTimelocks;
    $[1] = timelocks;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[5] !== pendingTimelocks.length || $[6] !== t2) {
    t3 = <PendingActionsList count={t1}>{t2}</PendingActionsList>;
    $[5] = pendingTimelocks.length;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const pendingActionsContent = t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon className="text-info-foreground hover:text-info-foreground" icon={<Timelock />} />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== pendingActionsContent) {
    t5 = <VaultPendingTimelockInfo content={pendingActionsContent}>{t4}</VaultPendingTimelockInfo>;
    $[9] = pendingActionsContent;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default VaultV2PendingTimelocksIndicator;